import { Card } from "@mui/material";
import React from "react";
import { LIST_GLD_LOG_TABLE_HEAD } from "../../variables/constants";
import { Typography } from "@material-tailwind/react";
import moment from "moment";

function GldLogsTable(props) {
  return (
    <div>
      <div className="mt-5 md:mt-8">
        {/* <div className="flex justify-between items-center mb-4">
          <p className="text-2xl font-bold text-black pb-2">
            Cylinder Weight Report
          </p>

          {props.cylinderList?.length > 0 && (
            <Button
              onClick={handleDownload}
              className="font-poppins font-medium tracking-wider bg-[#03438D]"
            >
              Download
            </Button>
          )}
        </div> */}

        {props.data?.length > 0 ? (
          <Card
            className="h-full w-full rounded-none overflow-x-scroll md:overflow-x-hidden"
            style={{
              boxShadow:
                "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.06)",
            }}
          >
            <table className="w-full min-w-max table-auto text-center">
              <thead>
                <tr>
                  {LIST_GLD_LOG_TABLE_HEAD.map((head) => (
                    <th
                      key={head}
                      className="border-b border-blue-gray-100 bg-[#03438D] p-4"
                    >
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-poppins text-white font-semibold uppercase"
                      >
                        {head}
                      </Typography>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.data.map((gld_log, index) => {
                  return (
                    <tr key={index}>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className={`font-poppins text-sm font-medium`}
                        >
                          {gld_log.zone}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className={`font-poppins text-sm font-medium`}
                        >
                          {gld_log.sensor}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className={`font-poppins text-sm font-medium`}
                        >
                          {gld_log.sen_status == 1
                            ? "Major Leakage"
                            : gld_log.sen_status == 2
                            ? "Minor Leakage"
                            : gld_log.sen_status == 3
                            ? "Sensor Fault"
                            : gld_log.sen_status == 4
                            ? "Power Off"
                            : gld_log.sen_status == 5
                            ? "Working"
                            : "-"}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className={`font-poppins text-sm font-medium`}
                        >
                          {gld_log.start_datetime
                            ? moment(gld_log.start_datetime).format(
                                "DD/MM/YYYY HH:mm"
                              )
                            : "-"}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className={`font-poppins text-sm font-medium`}
                        >
                          {gld_log.end_datetime
                            ? moment(gld_log.end_datetime).format(
                                "DD/MM/YYYY HH:mm"
                              )
                            : "-"}
                        </Typography>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card>
        ) : (
          <div className="text-center h-[50vh] flex flex-col justify-center items-center">
            <p className="font-semibold text-xl sm:text-3xl">
              Oops! No Data Found...
            </p>
            <p className="text-sm mt-2 ">
              Looks like we couldn't find any data.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default GldLogsTable;
